import styled, { css } from 'styled-components';

// TODO follow app theme

export const PanelOverlayWrapper = styled.div.attrs<{
  $width: number;
}>((props) => ({
  style: {
    width: props.$width,
  },
}))<{
  $stopAnimation: boolean;
  $rightOffset: number;
  $width: number;
}>`
  ${({ $rightOffset, $stopAnimation }) => css`
    background-color: white;
    position: fixed;
    z-index: 1030;
    min-width: 385px;
    right: ${$rightOffset}px;
    transition: ${$stopAnimation
      ? ''
      : 'width 0.4s ease-in-out, right 0.4s ease-in-out'};
    top: 0;
    height: 100%;
    display: flex;
    filter: drop-shadow(1rem 0 1.3rem #00000070);
  `}
`;

export const ResizeHandleWrapper = styled.button`
  cursor: ew-resize;

  &.draggable-resize {
    height: 100%;
    width: 10px;
    position: relative;
    right: 4px;
    z-index: -1;
  }

  &.tab-button-resize {
    height: 48px;
    width: 16px;
    position: absolute;
    left: -16px;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
    border: none;
    border-radius: 8px 0 0 8px;
    background-color: white;
    box-shadow: 0 0 2px 1px rgba(124, 124, 124, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(41, 41, 41, 1);
    transition:
      background-color 0.2s,
      color 0.2s;

    &:hover,
    &:focus {
      background-color: rgba(222, 222, 223, 1);
      color: #333;
    }

    &:focus {
      outline: 2px solid black;
    }
  }
`;
